import { render } from "./Upsell.vue?vue&type=template&id=4a49239d"
import script from "./Upsell.vue?vue&type=script&lang=js"
export * from "./Upsell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__